// src/app/routes/index.tsx
import PublicDocuments from 'app/features/documents/Public';
import AppLayout from 'app/layout/appLayout';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import AccountantRoutes from 'app/routes/AccountantRoutes';
import AdminRoutes from 'app/routes/AdminRoutes';
import AuthRoutes from 'app/routes/AuthRoutes';
import ClientRoutes from 'app/routes/ClientRoutes';
import AIMito from 'Components/AIMito/AIMito';
import PrivacyPolicyRoutes from 'app/routes/PrivacyPolicyRoutes';
import TestComponent from 'Components/TestComponent';
import ViewIcons from 'development/ViewIcons';
import Dashboard from 'app/features/dashboard';
import DashboardLayout from 'app/layout/dashboardLayout';
import { Link, Outlet, Route, Routes } from 'react-router-dom';
import { GoToHomePage, useAuth } from 'utils/AuthProvider';

function AuthenticatedGuard() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <GoToHomePage />;
}

function UnauthenticatedGuard() {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? <Outlet /> : <GoToHomePage />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route element={<AuthenticatedGuard />}>
          {ClientRoutes()}
          {AdminRoutes()}
          {AccountantRoutes()}
          <Route path="dashboard/*" element={<DashboardLayout />}>
            <Route path="home" element={<Dashboard />} />
            <Route path="ai-mito" element={<AIMito />} />
            <Route path="privacy-policy" element={<PrivacyPolicyRoutes />} />
          </Route>
        </Route>

        <Route element={<UnauthenticatedGuard />}>{AuthRoutes()}</Route>
        <Route
          path={`/:resourceType/:resourceId/public`}
          element={
            <ScrollContainer>
              <PublicDocuments />
            </ScrollContainer>
          }
        />
        <Route path="/dev/icons" element={<ViewIcons />} />
        <Route path="/test" element={<TestComponent />} />
        <Route path="*" element={<GoToHomePage />} />
      </Route>
    </Routes>
  );
}

export function NotFound() {
  return (
    <main style={{ padding: '1rem' }}>
      <>
        <p>404</p>
        <Link className="text-green hover:underline" to="/dashboard">
          Back to dashboard
        </Link>
      </>
    </main>
  );
}
